<template>
  <div class="note-footer" v-if="!isEditMode && !footerNoteValue">
  </div>
  <div class="note-footer" v-else>
    <div class="footer-text upper-line lower-line">
      <ScText tag="span" class="text" :field="fields.footer"/>
    </div>
  </div>
</template>

<script>
import { Image, Text } from '@sitecore-jss/sitecore-jss-vue'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'NoteFooter',

  props: {
    fields: {
      type: Object
    },

    rendering: {
      type: Object
    }
  },

  components: {
    ScImage: Image,
    ScText: Text
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    footerNoteValue () {
      const {
        footer
      } = this.fields

      return footer && footer.value
    }
  }
}
</script>

<style lang="scss" scoped>

.note-footer {

  .upper-line {
    border-top: $line-medium;
  }

  .lower-line {
    border-bottom: $line-medium;
  }

  .footer-text {
    position: relative;
    padding: $space-060 0;
    max-width: 44em;
    margin: 0 $space-060 $space-080;

    @include tablet {
      width: 80%;
      margin: auto;
      margin-bottom: $d-xxx-large;
    }

    .text {
      @include font('050');

      color: $color-slate-dark;
      font-style: italic;
    
      @include tablet {
        @include font('060');
      }
    }
  }
}
</style>
